import { Component } from '@theme/component';
/** Editorial video carousel with a native, keyboard-accessible lightbox. */
class ZuriPdpStories extends Component {
  opener;
  observer;
  connectedCallback(){
    super.connectedCallback();
    this.observer=new IntersectionObserver(entries=>{for(const e of entries){const v=e.target;if(e.isIntersecting&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&!this.refs.dialog?.open){v.play().catch(()=>{});}else v.pause();}},{threshold:.6});
    this.querySelectorAll('.zuri-stories__clip video').forEach(v=>this.observer.observe(v));
  }
  disconnectedCallback(){this.observer?.disconnect();this.querySelectorAll('video').forEach(v=>v.pause());super.disconnectedCallback();}
  previous(){this.refs.videoRow?.scrollBy({left:-this.refs.videoRow.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
  next(){this.refs.videoRow?.scrollBy({left:this.refs.videoRow.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
  /** @param {MouseEvent} event */
  openVideo(event){
    const button=event.target.closest('.zuri-stories__clip'),video=button?.querySelector('video');
    if(!video||!this.refs.fullVideo||!this.refs.dialog)return;
    this.opener=button;this.querySelectorAll('.zuri-stories__clip video').forEach(v=>v.pause());
    this.refs.fullVideo.src=video.currentSrc||video.querySelector('source[type="video/mp4"]')?.src||video.querySelector('source')?.src;
    this.refs.dialog.showModal();this.refs.fullVideo.play().catch(()=>{});
  }
  closeVideo(){this.refs.dialog?.close();}
  videoClosed(){this.refs.fullVideo?.pause();this.opener?.focus();}
}
if(!customElements.get('zuri-pdp-stories'))customElements.define('zuri-pdp-stories',ZuriPdpStories);
